import { AxiosPromise } from 'axios';
import {
  ISemester,
  IGetSemester,
  IGetSemesters,
  ISemesterMonth,
  IGetSemesterMonths,
  ISemesterCourse,
  IGetSemesterCourses,
  IGetCurrentSemester,
  IGetSemesterCourseMonths,
  IGetSemesterCourse,
  IGetStudentMonths,
  IGetLevelUpCourses,
  IGetLevelUpData1,
  IGetLevelUpData2,
  ILevelUpDataReq,
  IGetLevelUpStudents,
  ILevelUpStudentParams,
  IGetLevelUpResult,
  ILevelUpResultReq,
  ILevelUpStaticsReq,
} from '../models/semesters.model';
import axios from 'axios';
import QueryString from 'qs';

const uri = '/mgmt/semesters';
const courseUri = '/mgmt/semester-courses';

export const getSemester = (
  semesterCode: string,
): AxiosPromise<IGetSemester> => {
  return axios.get(`${uri}/${semesterCode}`);
};

export const getSemesters = (): AxiosPromise<IGetSemesters> => {
  return axios.get(uri);
};

export const getCurrentSemester = (): AxiosPromise<IGetCurrentSemester> => {
  return axios.get(`${uri}/semesters`);
};

export const getCurrentSemesterByType = (semesterType: string): AxiosPromise<IGetCurrentSemester> => {
  return axios.get(`${uri}/semesters/type?semesterType=${semesterType}`);
};

export const createSemester = (data: ISemester): AxiosPromise => {
  return axios.post(uri, data);
};

export const updateSemester = (id: string, data: ISemester): AxiosPromise => {
  return axios.put(`${uri}/${id}`, data);
};

export const getSemesterMonths = (
  semesterCode: string,
): AxiosPromise<IGetSemesterMonths> => {
  return axios.get(`${uri}/${semesterCode}/months`);
};

export const createSemesterMonths = (
  id: string,
  data: ISemesterMonth[],
): AxiosPromise => {
  return axios.post(`${uri}/months/${id}/month`, data);
};

export const updateSemesterMonths = (
  id: string,
  data: ISemesterMonth[],
): AxiosPromise => {
  return axios.put(`${uri}/months/${id}/month`, data);
};

export const getSemesterCourses = (
  semesterCode: string,
): AxiosPromise<IGetSemesterCourses> => {
  return axios.get(`${courseUri}/${semesterCode}/-1`);
};

export const getSemesterCourse = (
  semesterCourseCode: number,
): AxiosPromise<IGetSemesterCourse> => {
  return axios.get(`${courseUri}/${semesterCourseCode}`);
};

export const createSemesterCourses = (
  data: ISemesterCourse[],
): AxiosPromise => {
  return axios.post(courseUri, data);
};

export const updateSemesterCourses = (
  data: ISemesterCourse[],
): AxiosPromise => {
  return axios.put(courseUri, data);
};

export const createSemesterInfo = (id: string): AxiosPromise => {
  return axios.post(`${courseUri}/${id}`);
};

export const getSemesterCourseMonths = (
  semesterCourseCode: number,
): AxiosPromise<IGetSemesterCourseMonths> => {
  return axios.get(`${courseUri}/${semesterCourseCode}/months`);
};

export const getStudentMonths = (
  memberCode: string,
): AxiosPromise<IGetStudentMonths> => {
  return axios.get(`${uri}/${memberCode}/student-month`);
};

export const getLevelUpCourses = (
  semesterCode: string,
): AxiosPromise<IGetLevelUpCourses> => {
  return axios.get(`${uri}/${semesterCode}/open-course`);
};

export const getLevelUpData1 = (
  semesterCode: string,
  courseCode: number,
): AxiosPromise<IGetLevelUpData1> => {
  return axios.get(`${uri}/${semesterCode}/${courseCode}/level-up/basic-info`);
};

export const getLevelUpData2 = (
  levelUpCode: number,
): AxiosPromise<IGetLevelUpData2> => {
  return axios.get(`${uri}/${levelUpCode}/level-up/score-weight`);
};

export const getLevelUpResult = (
  levelUpCode: number,
): AxiosPromise<IGetLevelUpResult> => {
  return axios.get(`${uri}/${levelUpCode}/result`);
};

export const createLevelUpData = (data: ILevelUpDataReq): AxiosPromise => {
  return axios.post(`${uri}/level-up/setting`, data);
};

export const updateLevelUpData = (
  levelUpCode: number,
  data: ILevelUpDataReq,
): AxiosPromise => {
  return axios.put(`${uri}/level-up/setting/${levelUpCode}`, data);
};

export const toggleLevelUpDataOpen = (
  levelUpCode: number,
  data: { openYn: 'Y' | 'N' },
): AxiosPromise => {
  return axios.put(`${uri}/level-up/setting/${levelUpCode}/open`, data);
};

export const getLevelUpStudents = (
  params: ILevelUpStudentParams,
): AxiosPromise<IGetLevelUpStudents> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/level-up/student-list?${qsParams}`);
};

export const updateLevelUpResult = (data: ILevelUpResultReq): AxiosPromise => {
  return axios.put(`${uri}/level-up/modify/campus-result`, data);
};

export const completeCurrentSemester = (data: any): AxiosPromise => {
  return axios.put(`${uri}/complete`, data);
};
//20240718 레벨업 명단 통계를 위한 api 추가
export const getLevelUpStaticsData = (
  campusCode: any,
  semesterCode: any,
): AxiosPromise => {
  return axios.get(
    `${uri}/level-up/statics/campus/${campusCode}/semester/${semesterCode}`,
  );
};
